(() => {
  if (window.rushCartSafety) return;
  const config = document.querySelector('[data-cart-safety-config]');
  if (!config) return;
  const initial = JSON.parse(config.textContent);
  let routeStarted = false;
  const startRoute = () => {
    if (routeStarted) return false;
    routeStarted = true;
    if (!document.querySelector('script[src*="shopify-widget.route.com/shopify.widget.js"]')) {
      const routeScript = document.createElement('script');
      routeScript.src = initial.routeScript;
      routeScript.async = true;
      document.head.appendChild(routeScript);
    }
    return true;
  };
  const root = window.Shopify?.routes?.root || '/';
  const request = window.fetch.bind(window);
  const checkoutSelector = '.cart__checkout-button, .cart__dynamic-checkout-buttons';
  const routeItem = (item) => String(item.vendor || '').trim().toLowerCase() === 'route' || item.handle === 'routeins';
  const merchandise = (item) => !routeItem(item) && !initial.giftHandles.includes(item.handle);
  const signature = (cart) => JSON.stringify([cart.total_price, cart.items.map((item) => [item.key, item.quantity, item.final_line_price])]);
  let eligible = initial.eligible;
  let currentCart = null;
  let lastSignature = null;
  let inFlight = 0;
  let revision = 0;
  let timer;
  let running = false;
  let dirty = false;
  let failed = false;
  let queuedCheckout = null;
  let refreshing = false;

  const busy = () => inFlight > 0 || running || dirty;
  const updateControls = () => {
    if (currentCart) {
      const protectionTotal = currentCart.items.filter(routeItem).reduce((total, item) => total + item.final_line_price, 0);
      document.querySelectorAll('.route-div[data-subtotal-ref]').forEach((container) => {
        const widget = container.querySelector('route-protect-widget');
        if (!widget) return;
        const rawQuote = widget.getAttribute('quote');
        const amount = Number.parseFloat(String(rawQuote || '').replace(/[^0-9.]/g, ''));
        if (!Number.isFinite(amount)) return;
        const selected = widget.getAttribute('status') === 'true' && widget.getAttribute('payer') === 'customer';
        const protectionDelta = (selected ? Math.round(amount * 100) : 0) - protectionTotal;
        let cents = currentCart.total_price + protectionDelta;
        (currentCart.cart_level_discount_applications || []).forEach((discount) => {
          if (discount.target_type !== 'line_item' || discount.target_selection !== 'all' || discount.value_type !== 'percentage') return;
          const rate = Number(discount.value) / 100;
          const projectedDiscount = Math.floor((currentCart.items_subtotal_price + protectionDelta) * rate);
          cents += discount.total_allocated_amount - projectedDiscount;
        });
        const currency = currentCart.currency || initial.currency || 'USD';
        const text = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
        document.querySelectorAll(container.dataset.subtotalRef).forEach((element) => {
          const rendered = element.classList.contains('totals__total-value') ? text + ' ' + currency : text;
          if (element.textContent.trim() !== rendered) element.textContent = rendered;
        });
      });
    }
    document.querySelectorAll('.cart__checkout-button').forEach((button) => {
      button.disabled = !eligible || failed;
      button.setAttribute('aria-disabled', String(!eligible || failed || busy()));
    });
    document.querySelectorAll('.route-div, [data-cart-route-note]').forEach((element) => { element.hidden = !eligible; });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((element) => {
      element.hidden = !eligible || failed || busy();
    });
    document.querySelectorAll('cart-drawer, cart-items').forEach((element) => {
      element.classList.toggle('is-cart-syncing', busy());
      element.setAttribute('aria-busy', String(busy()));
    });
    document.querySelectorAll('[data-cart-safety-error]').forEach((element) => {
      element.hidden = !failed;
    });
  };

  const readCart = async () => {
    const response = await request(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart_read_failed');
    return response.json();
  };

  const preserveRoute = (target, render) => {
    const containers = [...target.querySelectorAll('.route-div')];
    render();
    containers.forEach((container) => {
      const replacement = [...target.querySelectorAll('.route-div')].find((node) => node.dataset.subtotalRef === container.dataset.subtotalRef);
      if (replacement) replacement.replaceWith(container);
    });
  };
  const renderSection = (target, html) => preserveRoute(target, () => { target.innerHTML = html; });

  const refresh = async () => {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const itemsSection = document.querySelector('#main-cart-items')?.dataset.id || 'main-cart-items';
    const footerSection = document.querySelector('#main-cart-footer')?.dataset.id || 'main-cart-footer';
    if (document.querySelector('cart-items')) ids.push(itemsSection, footerSection);
    const url = new URL(window.location.href);
    url.searchParams.set('sections', ids.join(','));
    const response = await request(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart_render_failed');
    const sections = await response.json();
    const parser = new DOMParser();
    const replacements = [];
    const collect = (html, selectors) => {
      if (!html) throw new Error('cart_section_missing');
      const page = parser.parseFromString(html, 'text/html');
      selectors.forEach((selector) => {
        const target = document.querySelector(selector);
        const source = page.querySelector(selector) || (selector === '#cart-icon-bubble' ? page.querySelector('.shopify-section') : null);
        if (target && !source) throw new Error('cart_section_invalid');
        if (target && source) replacements.push([target, source]);
      });
    };
    if (document.querySelector('cart-drawer')) {
      collect(sections['cart-drawer'], ['#CartDrawer-CartItems', '.drawer__header', '.cart-drawer__footer']);
    }
    collect(sections['cart-icon-bubble'], ['#cart-icon-bubble']);
    if (document.querySelector('cart-items')) {
      collect(sections[itemsSection], ['cart-items']);
      collect(sections[footerSection], ['#main-cart-footer .js-contents']);
    }
    refreshing = true;
    try {
      replacements.forEach(([target, source]) => {
        preserveRoute(target, () => target.replaceChildren(...source.childNodes));
      });
      const drawer = document.querySelector('cart-drawer');
      const overlay = drawer?.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
      const empty = !eligible;
      const existingEmpty = drawer?.querySelector('.drawer__inner-empty');
      if (eligible) existingEmpty?.remove();
      else if (drawer && !existingEmpty && sections['cart-drawer']) {
        const emptyPage = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const emptyContent = emptyPage.querySelector('.drawer__inner-empty');
        if (emptyContent) drawer.querySelector('.drawer__inner')?.prepend(emptyContent);
      }
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
      document.querySelector('cart-drawer-items')?.classList.toggle('is-empty', empty);
      document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', empty);
    } finally {
      refreshing = false;
    }
  };

  const reconcile = async () => {
    clearTimeout(timer);
    if (running || inFlight > 0) return;
    running = true;
    dirty = false;
    const version = revision;
    updateControls();
    try {
      let cart = await readCart();
      const hasMerchandise = cart.items.some(merchandise);
      const orphaned = hasMerchandise ? [] : cart.items.filter((item) => routeItem(item) || initial.giftHandles.includes(item.handle));
      if (orphaned.length) {
        const updates = Object.fromEntries(orphaned.map((item) => [item.key, 0]));
        const response = await request(`${root}cart/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates, attributes: { route_toggle_state: '0' } }),
        });
        if (!response.ok) throw new Error('cart_cleanup_failed');
        cart = await readCart();
      }
      if (version !== revision || inFlight > 0) {
        dirty = true;
        return;
      }
      eligible = cart.items.some(merchandise);
      currentCart = cart;
      const next = signature(cart);
      if (next !== lastSignature) {
        await refresh();
        if (version !== revision || inFlight > 0) {
          dirty = true;
          return;
        }
        lastSignature = next;
      }
      failed = false;
    } catch (error) {
      console.error('Cart synchronization failed', error);
      failed = true;
      queuedCheckout = null;
    } finally {
      running = false;
      updateControls();
      if (dirty && inFlight === 0) schedule();
      if (!busy() && !failed && eligible && queuedCheckout) {
        const button = queuedCheckout;
        queuedCheckout = null;
        if (button.isConnected) button.click();
      }
    }
  };

  const schedule = () => {
    dirty = true;
    clearTimeout(timer);
    timer = setTimeout(reconcile, 180);
    updateControls();
  };
  const begin = () => { inFlight += 1; revision += 1; updateControls(); };
  const end = () => { inFlight = Math.max(0, inFlight - 1); schedule(); };
  const isMutation = (input, options) => {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      const method = String(options?.method || input?.method || 'GET').toUpperCase();
      return url.origin === window.location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch (error) { return false; }
  };

  window.fetch = async function (input, options) {
    if (!isMutation(input, options)) return request(input, options);
    begin();
    try { return await request(input, options); } finally { end(); }
  };
  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.rushCartMutation = isMutation(String(url), { method });
    return open.call(this, method, url, ...args);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (!this.rushCartMutation) return send.apply(this, args);
    begin();
    this.addEventListener('loadend', end, { once: true });
    try { return send.apply(this, args); } catch (error) { end(); throw error; }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('#cart-icon-bubble, a[href$="/cart"], [aria-controls="CartDrawer"], .cart__checkout-button, .cart__dynamic-checkout-buttons') : null;
    if (trigger && startRoute()) schedule();
    const target = event.target instanceof Element ? event.target.closest(checkoutSelector) : null;
    if (!target || (eligible && !failed && !busy())) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (eligible && !failed) queuedCheckout = target;
  }, true);
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('#cart, #CartDrawer-Form')) return;
    if (event.submitter && event.submitter.name !== 'checkout' && !event.submitter.matches('.cart__checkout-button')) return;
    if (eligible && !failed && !busy()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (eligible && !failed) queuedCheckout = event.submitter;
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('cart-items .quantity__input, cart-drawer-items .quantity__input')) schedule();
  }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && routeStarted) schedule(); });
  window.addEventListener('pageshow', (event) => { if (event.persisted && routeStarted) schedule(); });
  let controlsFrame = 0;
  new MutationObserver((records) => {
    if (!routeStarted && records.some(record => record.attributeName === 'class' && record.target.matches('cart-drawer.active'))) {
      if (startRoute()) schedule();
    }
    if (refreshing || controlsFrame) return;
    if (!records.some(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      return target?.closest('cart-drawer, cart-items, #main-cart-footer, .route-div');
    })) return;
    controlsFrame = requestAnimationFrame(() => {
      controlsFrame = 0;
      updateControls();
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['status', 'quote', 'payer', 'class'] });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  window.rushCartSafety = { reconcile: schedule, renderSection };
  updateControls();
  if (document.querySelector('cart-items')) {
    startRoute();
    schedule();
  }
})();
